import { render } from "./nos_services.vue?vue&type=template&id=e58c76a0"
import script from "./nos_services.vue?vue&type=script&lang=js"
export * from "./nos_services.vue?vue&type=script&lang=js"

import "./nos_services.vue?vue&type=style&index=0&id=e58c76a0&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__